import React, { useEffect, useState } from 'react'
import { FormWrapper, Label, Select, Button, Input } from './shared_form_styles';
import { useDispatch, useSelector } from "react-redux";
import { addGrade, updateGrade } from '../actions/gradeActions';

export const GradeOnAssignment = ({ closePopup, assignmentId }) => {

  const subjectInstanceSelected = useSelector((state) =>
    state.selection.selectedSubjectInstance ? state.selection.selectedSubjectInstance : null);
  const studentSelected = useSelector((state) =>
    state.selection.selectedStudent ? state.selection.selectedStudent : null);
  const subjectInstancesArray = useSelector((state) =>
    state.subjectInstances ? state.subjectInstances : null);
  const studentsArray = useSelector((state) =>
    state.students ? state.students : null);
  const enrollmentsArray = useSelector((state) =>
    state.enrollments ? state.enrollments : null);
  const assignmentsArray = useSelector((state) =>
    state.assignments ? state.assignments : null);
  const gradesArray = useSelector((state) =>
    state.grades ? state.grades : null);

  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedAssignment, setSelectedAssignment] = useState("");
  const [grade, setGrade] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    const getValidEnrollments = () => 
      enrollmentsArray.filter(enrollment => 
        assignmentsArray.some(assignment => assignment.subjectInstance?._id === enrollment.subjectInstance._id)
      );
  
    const setFirstValidEnrollment = (validEnrollments) => {
      setSelectedStudent(validEnrollments[0]?.student);
      setSelectedSubject(validEnrollments[0]?.subjectInstance);
    };
  
    const validEnrollments = getValidEnrollments();
  
    if (!studentSelected && !subjectInstanceSelected) {
      setFirstValidEnrollment(validEnrollments);
    } else if (studentSelected && subjectInstanceSelected) {
      const filteredEnrollments = validEnrollments.filter(enrollment => 
        enrollment.student._id === studentSelected._id
      );
  
      if (filteredEnrollments.some(enrollment => enrollment.subjectInstance?._id === subjectInstanceSelected._id)) {
        setSelectedStudent(studentSelected);
        setSelectedSubject(subjectInstanceSelected);
      } else {
        setFirstValidEnrollment(validEnrollments);
      }
    } else if (subjectInstanceSelected) {
      const filteredEnrollments = validEnrollments.filter(enrollment => 
        enrollment.subjectInstance._id === subjectInstanceSelected._id
      );
  
      if (filteredEnrollments.length > 0) {
        setSelectedStudent(filteredEnrollments[0]?.student);
        setSelectedSubject(subjectInstanceSelected);
      } else {
        setFirstValidEnrollment(validEnrollments);
      }
    } else if (studentSelected) {
      const matchingEnrollment = validEnrollments.find(enrollment => 
        enrollment.student._id === studentSelected._id
      );
  
      if (matchingEnrollment) {
        setSelectedStudent(studentSelected);
        setSelectedSubject(matchingEnrollment.subjectInstance);
      } else {
        setFirstValidEnrollment(validEnrollments);
      }
    }
  }, [studentSelected, subjectInstanceSelected, enrollmentsArray, assignmentsArray]);
  
  

  useEffect(() => {
    if (selectedSubject && assignmentsArray && assignmentsArray.length > 0) {
      if (assignmentId && assignmentsArray.some(ass => ass._id === assignmentId && ass.subjectInstance._id === selectedSubject._id)) {
        setSelectedAssignment(assignmentsArray.find(ass => ass._id === assignmentId));
      } else {
        setSelectedAssignment(assignmentsArray.filter(ass => ass.subjectInstance._id === selectedSubject._id)[0]);
      }
    }
  }, [selectedSubject]);

  useEffect(() => {
    if (gradesArray && gradesArray.length > 0) {
      const grade = gradesArray.find(grade => (grade.assignment?._id == selectedAssignment?._id) && (grade.student?._id == studentSelected?._id));
      setGrade(grade ? grade.grade : "");
    } else {
      setGrade(0);
    }
  }, [selectedAssignment]);
  useEffect(() => {
    if (selectedAssignment && gradesArray && gradesArray.length > 0) {
      const grade = gradesArray.find(grade => (grade.assignment?._id == selectedAssignment?._id) && (grade.student?._id == selectedStudent?._id));
      setGrade(grade ? grade.grade : "");
    } else {
      setGrade(0);
    }
  }, [selectedAssignment, selectedStudent, gradesArray]);


  const handleSave = async () => {
    if (!selectedSubject._id || !selectedStudent._id || !selectedAssignment._id) {
      console.error('no subject, assignment or student selected');
      return
    }
    const enrollment = enrollmentsArray.find(en => en.subjectInstance._id === selectedSubject._id && en.student._id === selectedStudent._id);
    if (!enrollment) {
      console.error('No enrollment for the selected subject and student');
      return;
    }
    let input = {
      assignmentId: selectedAssignment._id,
      studentId: selectedStudent._id,
      grade: parseFloat(grade),
    };

    if (selectedAssignment.grades && gradesArray.find(ass => (ass.student._id == selectedStudent._id) && (ass.assignment._id == selectedAssignment._id))) {
      //is an update
      dispatch(updateGrade(input));
    } else {
      //is a creation
      dispatch(addGrade(input));
    }
  };


  const handleStudentChange = (e) => {
    const selectedStudentId = e.target.value;
    const student = enrollmentsArray.find(en => (en.student._id === selectedStudentId) && (en.subjectInstance._id === selectedSubject?._id))?.student;
    setSelectedStudent(student);
  };

  const handleSubjectChange = (e) => {
    const selectedSubjectId = e.target.value;
    const subject = enrollmentsArray.find(en => en.subjectInstance._id === selectedSubjectId)?.subjectInstance;
    setSelectedSubject(subject);
    const assignmentsOfSubject = assignmentsArray.filter(ass => ass.subjectInstance._id == subject._id);
    setSelectedAssignment(assignmentsOfSubject[0]);
  };
  const handleAssignmentChange = (e) => {
    const selectedAssignmentId = e.target.value;
    const assignment = assignmentsArray.find(ass => ass._id == selectedAssignmentId);
    setSelectedAssignment(assignment);
  };

  return (
    <FormWrapper>
      <Label>
        Student:
        <Select
          value={selectedStudent?._id}
          onChange={(e) => { handleStudentChange(e) }}
        >
          {enrollmentsArray && selectedSubject && enrollmentsArray
            .filter((enrollment) => (assignmentsArray.some((assignment) => (assignment.subjectInstance?._id === selectedSubject._id)) && (enrollment.subjectInstance._id === selectedSubject?._id)))
            .map((item, index) => (
              <option key={index} value={item.student._id}>{item.student.name}</option>
            ))}

        </Select>
      </Label>
      <Label>
        Subject:
        <Select
          value={selectedSubject?._id}
          onChange={(e) => { handleSubjectChange(e) }}
        >
          {enrollmentsArray && enrollmentsArray
            .filter((enrollment) => (assignmentsArray.some((assignment) => assignment.subjectInstance?._id === enrollment.subjectInstance._id)) && (enrollment.student._id === selectedStudent?._id))
            .map((item, index) => {
              return (
                <option key={index} value={item.subjectInstance._id}>{item.subjectInstance.subject?.name}</option>
              );
            })
          }
        </Select>
      </Label>
      <Label>
        Assignment:
        <Select
          value={selectedAssignment?._id}
          onChange={(e) => { handleAssignmentChange(e) }}
        >
          {assignmentsArray && assignmentsArray.filter((ass) =>
            ass.subjectInstance._id == selectedSubject?._id
          ).map((item, index) => (
            <option key={index} value={item._id}>{item.name}</option>
          ))}
        </Select>
      </Label>
      <Label>
        Grade:
        <Input
          type="text"
          name="grade"
          value={grade}
          placeholder='0'
          onChange={(e) => { setGrade(e.target.value) }}
        />
      </Label>
      <Button onClick={() => handleSave()}>Save</Button>
    </FormWrapper>
  );
};


export default GradeOnAssignment;
